<!-- eslint-disable @angular-eslint/template/prefer-control-flow -->
<app-layout-control>
  <app-control-label top [control]="control()" [caption]="caption()" />

  <dx-tab-panel #tabPanel [items]="['Design', 'HTML']" [selectedIndex]="0" [loop]="false" [animationEnabled]="false" [scrollByContent]="true">
    <div *dxTemplate="let item of 'title'">
      <span>{{ item }}</span>
    </div>
    <div *dxTemplate="let item of 'item'">
      <div>

        @if (item==='Design') {
          <div class="no-border" [ngStyle]="{'height': height()}">
            <dx-html-editor [ngClass]="readonly() ? 'disabled' : 'panel-content'" #htmlEditor height="100%" class="no-border" [name]="caption()" [value]="value()"
              (onValueChanged)="onInput($event)" [readOnly]="readonly()" [allowSoftLineBreak]="true">
              <dxo-toolbar [multiline]="true">
                @if (extendedToolbar()) {
                  <dxi-item name="undo"></dxi-item>
                }
                @if (extendedToolbar()) {
                  <dxi-item name="redo"></dxi-item>
                }
                @if (extendedToolbar()) {
                  <dxi-item name="separator"></dxi-item>
                }
                <dxi-item name="font" [acceptedValues]="['Arial', 'Georgia', 'Tahoma', 'Times New Roman', 'Verdana']"></dxi-item>
                <dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="bold"></dxi-item>
                <dxi-item name="italic"></dxi-item>
                <dxi-item name="strike"></dxi-item>
                <dxi-item name="underline"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="color"></dxi-item>
                @if (extendedToolbar()) {
                  <dxi-item name="background"></dxi-item>
                }
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="alignLeft"></dxi-item>
                <dxi-item name="alignCenter"></dxi-item>
                <dxi-item name="alignRight"></dxi-item>
                <dxi-item name="alignJustify"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="orderedList"></dxi-item>
                <dxi-item name="bulletList"></dxi-item>
                @if (extendedToolbar()) {
                  <dxi-item name="separator"></dxi-item>
                }
                @if (extendedToolbar()) {
                  <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
                }
                <dxi-item name="separator"></dxi-item>
                @if (extendedToolbar()) {
                  <dxi-item name="link"></dxi-item>
                }
                <dxi-item name="image"></dxi-item>
                @if (extendedToolbar()) {
                  <dxi-item name="separator"></dxi-item>
                }
                @if (extendedToolbar()) {
                  <dxi-item name="codeBlock"></dxi-item>
                }
                @if (extendedToolbar()) {
                  <dxi-item name="blockquote"></dxi-item>
                }
                @if (extendedToolbar()) {
                  <dxi-item name="separator"></dxi-item>
                }
                @if (extendedToolbar()) {
                  <dxi-item name="insertTable"></dxi-item>
                }
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="clear"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                @if (showMacroButton()) {
                  <dxi-item widget="dxButton" [options]="showMacroButtonOptions"></dxi-item>
                }
              </dxo-toolbar>
              <dxo-table-context-menu [enabled]="true">
              </dxo-table-context-menu>
              <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
              <dxo-image-upload [tabs]="['url', 'file']" fileUploadMode="base64">
              </dxo-image-upload>
            </dx-html-editor>
          </div>
        }
        @else {
        <div [ngStyle]="{'height': height()}">
          <dx-text-area [ngClass]="readonly() ? 'disabled' : 'panel-content'" #textArea height="100%" class="no-border" valueChangeEvent="focusout" [name]="caption()" [value]="value()"
            (onValueChanged)="onInput($event)" [readOnly]="readonly()">
          </dx-text-area>
        </div>
      }

    </div>
  </div>
</dx-tab-panel>

<app-control-supporting-text bottom [control]="control()" [controlName]="caption()" [isValid]="true" />

<dx-popup [showTitle]="true" title="Macros" [(visible)]="showMacroPopup" [hideOnOutsideClick]="true" [showCloseButton]="true" [width]="850" height="90vh" [restorePosition]="false"
  [resizeEnabled]="true">
  <div class="macroLayout">
    @for (item of macros(); track $index) {
      <div class="macroRow">
        <div>{{item.Macro}}</div>
        <div>{{item.Description}}</div>
        <div>
          <a class="copyToClipboard" (click)="copyToClipboard(item)">
            <p><i class="dx-icon-copy"></i> Copy to clipboard</p>
          </a>
        </div>
      </div>
    }
  </div>
</dx-popup>
</app-layout-control>
